import { useContext } from "react";
import { codePrintingContext } from "./UsersCodePrintingContext";

export const useShowCodePrintingCheckboxes = () => {
    const [{ showSelection }] = useContext(codePrintingContext);
    return showSelection;
};

export const usePrintStudentCodes = () => {
    const [_, setStudentsCodesPrinting] = useContext(codePrintingContext);
    return () => {
        setTimeout(() => {
            window.print();
            setStudentsCodesPrinting((curr) => ({
                ...curr,
                showSelection: false,
                selectedStudents: [],
            }));
        }, 100);
    };
};

export const useActivatePrintingSelection = () => {
    const [_, setStudentsCodesPrinting] = useContext(codePrintingContext);
    return () => {
        setStudentsCodesPrinting((curr) => ({ ...curr, showSelection: true }));
    };
};
